import { render, staticRenderFns } from "./split-modal.vue?vue&type=template&id=28fe9071&scoped=true"
import script from "./split-modal.vue?vue&type=script&lang=js"
export * from "./split-modal.vue?vue&type=script&lang=js"
import style0 from "./split-modal.vue?vue&type=style&index=0&id=28fe9071&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fe9071",
  null
  
)

export default component.exports